









import Vue from "vue"
import Page from "../../../components/Page.vue";

import store, { ObjectMarkStore } from "../services/ObjectMarkStore";
import ObjectMarksEditor from "./ObjectMarksEditor.vue";

interface Data {
  store: ObjectMarkStore;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
    ObjectMarksEditor,
  },

  data() {
    return {
      store,
    };
  },

  methods: {
    //
  },

  computed: {
    //
  },
})
